import { render, staticRenderFns } from "./invt_liste.vue?vue&type=template&id=6dbac383&"
import script from "./invt_liste.vue?vue&type=script&lang=js&"
export * from "./invt_liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports